import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import getClienti from "../services/getClienti";
import deleteCliente from "../services/deleteCliente";
import checkToken from "../services/checkToken";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class Clienti extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoading: true
    };
  }

  async reload() {
    this.setState({ isLoading: true });
    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });
    const check = await checkToken(username, token, true);
    const userType = parseInt(check.utente.tipo);
    let addClienteLink = '';
    let editClienteLink = '';

    switch (userType) {
      case 0:
        addClienteLink = '/#/app/addCliente';
        editClienteLink = '/#/app/editCliente';
        break;
      case 3:
        addClienteLink = '/#/commerciale/addCliente';
        editClienteLink = '/#/commerciale/editCliente';
        break;
      default:
        addClienteLink = '';
    }

    await getClienti(username, token).then(res => {
      const clienti = res.filter((cliente) => cliente.cestino === '0')
      this.setState({ ...this.state, clienti })
    });

    this.setState({ isLoading: false, addClienteLink: addClienteLink, editClienteLink: editClienteLink, userType });
  }

  async componentDidMount() {
    await this.reload();
  }

  async delete(id) {
    if (window.confirm("Sei sicuro di voler eliminare questo cliente?") === false) return;

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    await deleteCliente(username, token, id);
    this.reload();
  }


  render() {

    if (this.state.isLoading)
      return <Loading />;

    const cookies = new Cookies();

    var headCells = [
      { id: 'ragione_sociale', numeric: false, disablePadding: true, label: 'Cliente' },
      { id: 'p_iva', numeric: true, disablePadding: false, label: 'P.IVA/Cod. Fiscale' },
      { id: 'in_revisione', numeric: true, disablePadding: false, label: 'Stato', chip: true },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];

    this.searchCols = ['name'];

    return (
      <div id={Math.random()}>
        <PageTitle title="Clienti" button="CREA NUOVO" onClick={() => {
          window.location.href = this.state.addClienteLink;
        }} />

        <Table headCells={headCells} searchCols={this.searchCols} rows={this.state.clienti}
          onEventClick={(row) => {
            cookies.set('cliente', row, { path: '/' });
            window.location.href = this.state.editClienteLink;
          }}
          onDelete={this.state.userType === 0 ? this.delete.bind(this) : null}
        />

      </div>
    );
  }
}

